import { Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { NgFor, NgIf, JsonPipe } from '@angular/common';
import NavModel from "../../model/NavModel"
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config/app.config';
import { APP_CONFIG } from '../../config/config.token';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CampaignSwitcherComponent } from '../campaign-switcher/campaign-switcher.component';
import { SidebarModule } from 'primeng/sidebar';
import { MainModel } from '../../model/MainModel';
import App from '../../model/App';
import { NavService } from '../../services/ui/NavService';
import { UserPermissionsService } from '../../services/permissions/UserPermissionsService';
import { AccountSettingsComponent } from '../../../vortex/page/account-settings/account-settings.component';
import { DialogModule } from 'primeng/dialog';
import { SearchCacheService } from '../../../vortex/services/searchcache.service';

@Component({
  selector: 'app-app-nav',
  standalone: true,
  imports: [JsonPipe, NgIf, CampaignSwitcherComponent, SidebarModule, NgFor, AccountSettingsComponent, DialogModule],
  templateUrl: './app-bar.component.html',
  styleUrl: './app-bar.component.scss'
})
export class AppBarComponent {

  isSwitcherShwon: boolean = false;
  showAccountDetailsModal: boolean = false;
  @Input() mode: "full"|"apps-only"|"account-only" = "full";

  constructor(
    private sanitizer: DomSanitizer,
    protected model: MainModel,
    private http: HttpClient,
    private msgService: MessageService,
    private searchCache: SearchCacheService,
    private navService: NavService,
    private permissionsAPI: UserPermissionsService,
    private router: Router,
    @Inject(APP_CONFIG) private config: AppConfig,
  ){
    // TODO: Check this onload from the session for last accessed application...
    // this.model.navigation.setCurrentNavModel(model.user);
  }

  onAppClick(app:App):void {
    console.debug("appclick");
    this.navService.setCurrentNavModel(app);
  }

  showAccountDetails(): void {
    this.showAccountDetailsModal = true;
  }

  logout() {
    this.http.post(`${this.config.apiUrl}authentication/logout`, {}, {withCredentials: true}).subscribe({
      next: (data) => {
        this.msgService.add({ severity: 'success', summary: 'Logout', detail: 'User logged out successfully!' });
      
        // Clear cache on logout
        this.searchCache.clearAll();
        this.model.navigation = new NavModel();
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      },
      error: (err) => {
        this.msgService.add({ severity: 'error', summary: 'Error', detail: 'Error while logging out user!' });
      }
    })
  }

  closeAccountSettingsDialog() {
    this.showAccountDetailsModal = false;
  }
}
